import { Component, OnInit,Input } from '@angular/core';
import { PM_Itme_Interface } from 'src/app/Interface/PM_Itme_Interface';
import { Empty_PM_Service_Interface, PM_Service_Interface } from 'src/app/Interface/PM_Service_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { PM_SubmitService } from 'src/app/Service/PM/PM_Submit.service';

@Component({
  selector: 'app-PMSubmitForm',
  templateUrl: './PMSubmitForm.component.html',
  styleUrls: ['./PMSubmitForm.component.scss']
})
export class PMSubmitFormComponent implements OnInit {

  @Input() inner_PM: PM_Service_Interface = Empty_PM_Service_Interface()
  Token: String = ""
  Submit_Dsc: string = ""
  InProccessing:boolean=false
  Done:boolean=false



  constructor(
    private PM_Submit_Service: PM_SubmitService,
    private Nav_Service: NavService,
    private Alertify_Service: AlertifyService,
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token, 1163).subscribe(
      data => {
        this.Read_PM_Item()
      }
      , error => {
        localStorage.clear()
        location.reload();
      }
    )

  }


  //#region PM Item

  DataList_PM_Item: Array<PM_Itme_Interface> = []
  Read_PM_Item() {
    this.PM_Submit_Service.GetServiceItem(this.Token,this.inner_PM.program_id).subscribe(
      data => {
        this.DataList_PM_Item = data
      }, error => {
        localStorage.clear()
        location.reload();
      }
    )
  }

  item_Data_Change(item: PM_Itme_Interface)
  {
    item.selected=!item.selected
  }

    //#endregion

  SubmitPMForm(datepickerInputServiceDate) {

    var SelectedAll:boolean=true
    var SelectedItem: Array<number> = []
    for (let item of this.DataList_PM_Item)
    {
      for (let item2 of item.detail)
      {
        if (item2.selected)
        {
          SelectedItem.push(item2.id)
        }
        else {
          SelectedAll=false
          this.Alertify_Service.ErrorMessage("The option "+item2.title+" has not been reviewed.")
        }
      }
    }

    if (!SelectedAll)
    {

    }
    else if (!this.Submit_Dsc || this.Submit_Dsc.length < 50)
    {
      this.Alertify_Service.ErrorMessage("Enter a description of at least 50 characters.")
    }
    else {
      this.InProccessing = true
      this.PM_Submit_Service.SubmitService(datepickerInputServiceDate,
        this.Submit_Dsc,
        this.inner_PM.id,
        this.inner_PM.type,
        SelectedItem,
        this.Token).subscribe(
          data => {
            this.InProccessing = false
            if (data['id'] == -1)
              this.Alertify_Service.ErrorMessage("The service date must be today.")
            else if (data['id'] == -2)
              this.Alertify_Service.ErrorMessage("The service date cannot be in the future.")
            else if (data['id'] == -3)
              this.Alertify_Service.ErrorMessage("The service date cannot be more than 3 days in the past.")
            else if (data['id'] == -4)
              this.Alertify_Service.ErrorMessage("The service date cannot be earlier than the previous service date.")
            else {
              this.Alertify_Service.SuccessMessage("Service registered successfully.")
              this.Done=true
            }

          }
        )
    }

  }

}
